module.exports = __webpack_public_path__ + "cf8593b1b7c418877724d313131c9049.svg";